<template>
  <div>
    <i class="fas fa-check-circle" :class="[stock ? 'product__status__icon' : 'product__status__info']"></i>
    <span class="product__status__info">{{ stockText }}</span>
  </div>
</template>
<script>
  export default {
    props: {
      stock: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      stockText: function() {
        return this.stock ? '在庫あり' : '在庫切れ'
      }
    }
  }
</script>
